import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators";
import { auth } from "@/protos";
import store from "@/store";
import { AuthClient } from "@/clients/auth_client";

const STORAGE_KEY = "AUTH";

export interface IAuthState {
  user: auth.IUser | null;
  credentials: auth.IAuthCredential | null;
}

@Module({
  store,
  name: "auth",
  dynamic: true,
  namespaced: true,
  stateFactory: true,
})
export default class Auth extends VuexModule implements IAuthState {
  public user: auth.IUser | null = null;
  public credentials: auth.IAuthCredential | null = null;

  get isLoggedIn(): boolean {
    return !!this.user?.id && this.user?.id === this.credentials?.userId;
  }

  @Mutation
  private CHANGE_DATA(data?: IAuthState): void {
    this.user = data?.user || null;
    this.credentials = data?.credentials || null;
  }

  @Action
  public async init() {
    let data: any = null;
    const savedData = localStorage.getItem(STORAGE_KEY);
    if (savedData) {
      data = JSON.parse(savedData);
    }
    this.CHANGE_DATA(data);
  }

  @Action
  public async clear() {
    localStorage.removeItem(STORAGE_KEY);
    this.CHANGE_DATA();
  }

  @Action
  public async update(data: IAuthState) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    this.CHANGE_DATA(data);
  }
}

export const AuthModule = getModule(Auth);

// Load stored auth data from localStorage
AuthModule.init();
